<template>
  <form action="#" @submit.prevent="updateProfile">
    <div class="form-floating mb-4">
      <input
        id="displayName"
        v-model="displayName"
        :class="displayNameClass"
        class="form-control"
        :placeholder="$t('displayName')"
        required
        type="text"
      />
      <label for="displayName"> {{ $t("displayName") }} </label>
    </div>

    <div class="form-floating mb-4">
      <input
        id="title"
        v-model="title"
        class="form-control"
        :placeholder="$t('title')"
        type="text"
      />
      <label for="title"> {{ $t("title") }} </label>
    </div>

    <button
      :disabled="!showResetForm || loading"
      class="btn btn-secondary w-100"
      type="submit"
    >
      <spinner v-if="loading" centered />
      <span v-else>{{ $t("updateProfile") }}</span>
    </button>

    <button
      v-if="showResetForm"
      :disabled="loading"
      class="btn btn-light w-100 mt-4"
      type="button"
      @click="resetForm"
    >
      {{ $t("cancel") }}
    </button>

    <div v-if="noChanges" class="alert alert-danger text-center mt-4">
      {{ $t("noChanges") }}
    </div>

    <div v-if="success" class="alert alert-success text-center mt-4">
      {{ $t("updateProfileSuccess") }}
    </div>

    <div v-if="error" class="alert alert-danger text-center mt-4">
      {{ $t("errorOnUpdate") }}
    </div>
  </form>
</template>

<script>
import Spinner from "../Spinner";

export default {
  name: "UpdateProfileForm",
  components: {
    Spinner,
  },
  data() {
    return {
      file: null,
      displayName: null,
      displayNameClass: null,
      title: null,
      loading: false,
      success: false,
      noChanges: false,
      error: false,
    };
  },
  computed: {
    oldValue() {
      return {
        displayName: this.$store.getters["user/getUser"].displayName,
        title: this.$store.getters["user/getUser"].title,
      };
    },
    showResetForm() {
      let $return = false;

      if (this.displayName !== this.oldValue.displayName) {
        $return = true;
      }
      if (this.title !== this.oldValue.title) {
        $return = true;
      }

      return $return;
    },
  },
  methods: {
    resetForm() {
      this.displayName = this.oldValue.displayName;
      this.title = this.oldValue.title;
      this.success = false;
      this.noChanges = false;
    },
    async updateProfile() {
      this.success = false;
      this.noChanges = false;
      this.error = false;

      if (
        (this.displayName === this.oldValue.displayName || !this.displayName) &&
        this.title === this.oldValue.title
      ) {
        this.noChanges = true;
      } else {
        this.loading = true;

        const _this = this;

        if (this.displayName !== this.oldValue.displayName) {
          await this.$store
            .dispatch("user/updateUser", {
              newDisplayName: this.displayName,
            })
            .catch(() => {
              _this.error = true;
            });
        }

        if (this.title !== this.oldValue.title) {
          await this.$store
            .dispatch("user/updateUser", {
              newTitle: this.title,
            })
            .catch(() => {
              _this.error = true;
            });
        }

        if (!_this.error) {
          _this.success = true;
        }

        _this.loading = false;
      }
    },
  },
  watch: {
    displayName(newDisplayName) {
      if (newDisplayName === null || newDisplayName.trim().length === 0) {
        this.displayNameClass = "is-invalid";
      } else if (newDisplayName === this.oldValue.displayName) {
        this.displayNameClass = null;
      } else {
        this.displayNameClass = "is-valid";
      }

      if (newDisplayName === null || newDisplayName.trim().length === 0) {
        this.displayName = null;
      } else if (newDisplayName.slice(0, 1) === " ") {
        this.displayName = newDisplayName.substring(1);
      } else {
        this.displayName = newDisplayName.replace(/  +/g, " ");
      }
    },
    title(newtitle) {
      if (newtitle === null || newtitle.trim().length === 0) {
        this.title = null;
      } else if (newtitle.slice(0, 1) === " ") {
        this.title = newtitle.substring(1);
      } else {
        this.title = newtitle.replace(/  +/g, " ");
      }
    },
  },
  mounted() {
    this.displayName = this.oldValue.displayName;
    this.title = this.oldValue.title;
  },
};
</script>

<style scoped></style>
